import { FontAwesomeIcon, FormFieldWithIcon, NotificationHub, RichTable } from "@nef/core"
import { useCallback, useRef, useState } from "react"
import { useDispatch } from "react-redux"

import {debounce} from "../../utils/common"
import { AppDispatch } from "../../app/store"
import { fetchIssuersOnSearch } from "../../redux/issuers/actions"
import issuerSearchColumns from "../../constants/table/issuerSearchColumns"
import { TABLE_EMPTY_API_DATA, TABLE_EMPTY_STATE_MESSAGE } from "../../constants/common"

const SearchableIssuer = ({ 
  setSelectedIssuer, 
  defaultValue = "", 
  isOptional = false, 
  showOnlyActive = false, 
  isAdmin = false,
  isPrice = false
}: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [showSearchDropdown, setShowSearchDropdown] = useState<boolean>(false)
  const [searchResults, setSearchResults] = useState([])
  const dispatch = useDispatch<AppDispatch>()
  const searchRef = useRef<HTMLInputElement>(null)

  // api to get the search results
  const getSearchData = async (token: string) => {
    try {
      setIsLoading(true)
      const payload: any = {
        searchString: token,
        searchType: "StartsWith",
        pageSize: 0,
        pageNumber: 0
      }
      if (showOnlyActive) {
        payload.active = true
      }
      if (isAdmin) {
        payload.admin = true
      }
      if (isPrice) {
        payload.price = true
      }
      const res = await dispatch(fetchIssuersOnSearch(payload)).unwrap()
      if (res?.length && searchRef?.current?.value) setSearchResults(res)
      else setSearchResults([])
      setIsLoading(false)
    } catch (error) {
      NotificationHub.send("danger", "Error fetching instrument details from search")
      setIsLoading(false)
    }
  }

  // handler for the issuer search
  const handleIssuerSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length < 3) {
      setSearchResults([])
      return
    }
    debouncedSearch(e.target.value)
  }

  const debouncedSearch = useCallback(debounce(getSearchData), [])

  // handler for issuer select
  const handleIssuerSelect = ({ row: { original: issuer } }: any) => {
    setSelectedIssuer(issuer)
    if (searchRef.current) {
      searchRef.current.value = issuer?.issuerName;
    }
  }

  return (
    <div className="issuer-search__search-wrapper">
      <FormFieldWithIcon
        label="Issuer"
        placeholder="Search issuer"
        name="instrumentSearch"
        onChange={handleIssuerSearch}
        iconClassName="fa-search"
        addonType="append"
        optional={isOptional}
        onFocus={() => setShowSearchDropdown(true)}
        autoComplete="off"
        ref={searchRef}
        defaultValue={defaultValue}
        data-testid="issuerSearch"
      />

      {showSearchDropdown && (
        <>
          <div className="issuer-search__dropdown">
            <RichTable
              className="rich-table"
              bodyHeight={200}
              options={{
                columns: issuerSearchColumns(),
                data: searchResults
              }}
              isPaginationEnabled={false}
              rowBgPattern="border"
              emptyStateMessage={searchResults.length ? TABLE_EMPTY_STATE_MESSAGE : TABLE_EMPTY_API_DATA}
              loading={isLoading}
              onRowClick={(e: any) => {
                handleIssuerSelect(e)
                // hide the results container
                setShowSearchDropdown(false)
              }}
            />
          </div>
          <div className="issuer-search__close">
            <FontAwesomeIcon className="issuer-search__close-icon" iconClassName="fa-times" onClick={() => setShowSearchDropdown(false)} />
          </div>
        </>
      )}
    </div>
  )
}

export default SearchableIssuer
